
import api from './api';

class Review {

	constructor (Api) {
		this.Api = Api;
	}

	all (query) {
		return this.Api.get({
			url:  'v1.1/m/reviews',
			query,
		});
	}

	reply (review, comment) {
		return this.Api.put({
			url:  'v1.1/m/reviews/comment/'+review,
			body: {
				text: comment,
			},
		});
	}

	storeInfo(query){
		return this.Api.get({
			url:  'v1.1/m/stores/reviews',
			query, 
		}).then(response => response.result);
	}

}

Review.$inject = ['Api'];

export default angular.module('service.review', [api])
	.service('Review', Review)
	.name;



// WEBPACK FOOTER //
// ./src/service/review.js